function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-search",
  "data-name": "Icon feather-search",
  transform: "translate(1.25 1.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1258",
  "data-name": "Path 1258",
  d: "M26.487,15.493A10.993,10.993,0,1,1,15.493,4.5,10.993,10.993,0,0,1,26.487,15.493Z",
  transform: "translate(-4.5 -4.5)",
  fill: "none",
  stroke: "#f86542",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1259",
  "data-name": "Path 1259",
  d: "M30.953,30.953l-5.978-5.978",
  transform: "translate(-6.217 -6.217)",
  fill: "none",
  stroke: "#f86542",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5
}));

var SvgIconSearchOrange = function SvgIconSearchOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.753,
    height: 27.753,
    viewBox: "0 0 27.753 27.753",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearchOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-search-orange.f5901677.svg";
export { ForwardRef as ReactComponent };